<template>
  <MainSiteLayout v-bind="{ content }">
    <PolymorphicPageMain v-bind="$props" />
  </MainSiteLayout>
</template>

<script>
import { contentQueryFragment } from './PolymorphicPageMain.vue'
export const contentQuery = `
  *[_id == $pageId][0]{
    ${contentQueryFragment}
  }
`
</script>

<script setup>
import { provide } from 'vue'

import MainSiteLayout from '../layouts/MainSiteLayout.vue'
import PolymorphicPageMain from './PolymorphicPageMain.vue'

const { breadcrumbs, content } = defineProps({
  breadcrumbs: Array,
  content: Object,
})

provide('locale', content.locale)
</script>
